import React from "react";
import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";

const AttendanceLegendCard = () => {
  const { t } = useTranslation();
  return (
  <Card className="bg-muted/40">
    <CardContent className="pt-6">
      <div className="flex items-center gap-6 flex-wrap">
        <div className="flex items-center gap-2">
          <Badge variant="default">{t("attComp.entry")}</Badge>
          <span className="text-sm">{t("attComp.legend.entryPunch")}</span>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant="secondary">{t("attComp.exit")}</Badge>
          <span className="text-sm">{t("attComp.legend.exitPunch")}</span>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant="outline" className="gap-1">
            <Clock className="h-3 w-3" />
            pending
          </Badge>
          <span className="text-sm">{t("attComp.legend.pendingProcessing")}</span>
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default AttendanceLegendCard;
